var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"iconTitle",class:{orange: _vm.theme == 'orange', blue: _vm.theme == 'blue'}},[_vm._v("\n  "+_vm._s(_vm.text)+"\n  "),(_vm.hasBlock)?_c('div',{staticClass:"separator"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }